module.exports = __webpack_public_path__ + "static/media/1_pl.d10b6f2c.png";